export const sunburstTokens = {
    tokens: {
        blendBackground: '#ffd848',
        blendIntersection: '#ff7600',
        blendForeground: '#ffbb00',
        gradientColorZero: '#ff9a15',
        gradientColorOne: '#ff7600',
        gradientColorTwo: '#ffa829',
        gradientColorThree: '#ffdf56',
        gradientColorZeroTransparent: '#ff9a1500',
        gradientColorOneTransparent: '#ff760000',
        gradientColorTwoTransparent: '#ffa82900',
        gradientColorThreeTransparent: '#ffdf5600'
    },
    themeTokens: {
        dark: {
            blendBackground: '#ff7700',
            blendIntersection: '#ffea9e',
            blendForeground: '#ffbb00'
        }
    },
    accents: {
        yellow: {
            tokens: {
                accentColor: '#fab000'
            },
            themeTokens: {
                dark: {
                    accentColor: '#ffce48'
                }
            }
        },
        orange: {
            tokens: {
                accentColor: '#ff7600'
            },
            themeTokens: {
                dark: {
                    accentColor: '#ff7c0c'
                }
            }
        }
    }
};

//# sourceMappingURL=Sunburst.js.map